<template><div><h1 id="eb-debitorenjournal-per-stichdatum" tabindex="-1"><a class="header-anchor" href="#eb-debitorenjournal-per-stichdatum"><span>EB-Debitorenjournal per Stichdatum</span></a></h1>
<p>EB-Debitorenjournal per Stichdatum — Listet alle Einzelbuchungen auf, die zu einem bestimmten Datum offen waren</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung &quot;EB-Debitorenjournal per Stichdatum&quot; listet alle Einzelbuchungen auf, die zu einem bestimmten Datum offen waren ( in den OP als offen erscheinen. Nach Wahl werden entweder alle EB ausgegeben, die per Stichdatum ([Datum1]) offen waren oder nur jene EB, welche per [Datum1] offen waren, und per Ausgleichsdatum ( [Datum2]) noch nicht ausgeglichen. Dies wird automatisch so gewählt bei unterschiedlichem Datum zwischen Stichdatum und Ausgleichsdatum.</p>
<p>Pro Adresse-Fakturanummer-DatumAbsteigend (=Sortierungskriterien) werden allerdings immer alle Buchungen aufgelistet, um den Geschäftsvorfall nachvollziehen zu können. Auf der letzten Zeile pro Fakturanummer wird dann der offene Saldo pro Fakturanummer ausgewiesen.</p>
<p>Dabei gelten folgende Regeln: Wenn [Datum1] = [Datum2], entspricht der Saldo dem offenen Betrag der Fakturanummer zu diesem Datum. Wenn [Datum1] &lt; [Datum2], entspricht der Saldo den offenen Fakturanummern, welche per [Datum1] offen waren, und per [Datum2] noch nicht ausgeglichen. EB, welche erst im Zeitraum zwischen [Datum1] und [Datum2] entstanden sind, werden nicht berücksichtigt! Wird [Datum1] &gt; [Datum2] vom Benutzer eingegeben, korrigiert das System dies uns setzt beide Daten auf [Datum1].</p>
<p>Am Schluss der Auswertung wird eine Rekapitulation angezeigt nach Alter der Forderungen. Ausgehend vom Stichdatum werden die offenen Saldi der einzelnen EB pro Fakturanummer in Kategorien eingeteilt. Beispiel: Stichdatum 31.12.98. Eine Rechnung mit Fakturadatum vom 20.11.98 erscheint in der Kategorie 31 bis 60Tage. Dies gilt auch dann, wenn zum Ausgleichsdatum 31.3.99 diese Faktura immer noch offen ist, und dementsprechend bereits 90 Tage älter ist!</p>
<p>Die Standardsortierung erfolgt nach Personen-ID aufsteigend, innerhalb der Personen-ID nach Fakturanummer aufsteigend, innerhalb der Fakturanummer nach Buchungsdatum absteigend. Damit erscheinen die kritischsten Geschäftsfälle pro Adresse zuerst.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → EB-Kontoauszüge → EB-Debitoren-Journal per Stichdatum</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Von Personen-ID:</dt>
<dd>
<p>Eingrenzung nach Personen-ID, inklusive</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Eingrenzung nach Personen-ID, inklusive: nur 1 Feld ausgefüllt = einzelne Personen-ID</p>
</dd>
<dt>Stichdatum:</dt>
<dd>
<p>Stichdatum OP: Datum, zu welchem ein offener Posten ausgewiesen werden soll (=Spalte 1). Im Text auch [Datum1].</p>
</dd>
<dt>Ausgleichsdatum:</dt>
<dd>
<p>Stichdatum Ausgleich: Datum, zu welchem ein offener Posten ausgeglichen sein sollte, d.h. Berücksichtigung der Zahlungseingänge bis und mit dieses Datum (= Spalte 2). Im Text auch [Datum2].</p>
</dd>
<dt>Nur mit Filter:</dt>
<dd>
<p>Eingrenzung nach Adressfilter (zusätzliche Eingrenzung der auszuwertenden Debitoren)</p>
</dd>
<dt>Ausgabeformat:</dt>
<dd>
<ol>
<li>detaillierte EB: nur EB, welche per [Datum1] bestanden haben, UND welche per [Datum2] immer noch offen sind (d.h. in der Zwischenzeit nicht ausgeglichen wurden), werden aufgelistet.</li>
</ol>
</dd>
<dd>
<ol start="2">
<li>nur Totale pro Adresse / Fakturanummer, mit denselben Kriterien wie detaillierte EB</li>
</ol>
</dd>
<dd>
<ol start="3">
<li>nur Total der Auswertung: zeigt nur das Total der Liste zum Abgleich mit der Buchhaltung</li>
</ol>
</dd>
<dt>Ausgabe</dt>
<dd>
<p>Standard (Drucker: A4-Portrait)</p>
</dd>
<dt>Bildschirm:</dt>
<dd>
<p>ja</p>
</dd>
<dt>Drucker/Format:</dt>
<dd>
<p>A4 quer</p>
</dd>
<dt>Hintergrundverarb.:</dt>
<dd>
<p>ja</p>
</dd>
</dl>
<p>:</p>
<h2 id="output-liste-detaillierte-eb-und-nur-totale-pro-adresse-fakturanummer" tabindex="-1"><a class="header-anchor" href="#output-liste-detaillierte-eb-und-nur-totale-pro-adresse-fakturanummer"><span>Output (Liste)(detaillierte EB&quot; und &quot;nur Totale pro Adresse/ Fakturanummer)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Spalten:</td>
<td></td>
</tr>
<tr>
<td>Adresse:</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>FaktNr:</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>Datum:</td>
<td>Buchungsdatum</td>
</tr>
<tr>
<td>T:</td>
<td>Buchungstyp</td>
</tr>
<tr>
<td>Betrag:</td>
<td>Buchungsbetrag</td>
</tr>
<tr>
<td>EB Stichdatum:</td>
<td>Saldo der EB-Buchungen pro Fakturanummer per [Datum1] ( jeweils nur auf letzter Zeile pro Fakturanummer)</td>
</tr>
<tr>
<td>EB Ausgleichsdatum:</td>
<td>Saldo der EB-Buchungen per [Datum2] (wenn Ausgleich der Faktura in der Zwischenzeit: leer)</td>
</tr>
<tr>
<td>Name:</td>
<td>Adressname</td>
</tr>
<tr>
<td>Zeilen:</td>
<td></td>
</tr>
<tr>
<td>Total:</td>
<td>Summe der einzelnen Spalten</td>
</tr>
<tr>
<td>Rekapitulation:</td>
<td>Alter der Forderungen bezogen auf das Stichdatum [Datum1] mit Anzahl und Wert. Alter der Forderungen rechnet sich aus der Differenz zwischen [jüngstes Belegdatum zu einer Fakturanummer] und [Datum1]. Die Einteilung erfolgt in die bisherigen Kategorien 1-30; 31-60; 61-90; 91-150; 151 und mehr Tage. Der Zeitraum zwischen dem Stichdatum und dem aktuellen Tagesdatum, zu dem die Auswertung durchgeführt wird, wird also nicht ausgewiesen.</td>
</tr>
</tbody>
</table>
<h2 id="output-liste-nur-totale-der-auswertung" tabindex="-1"><a class="header-anchor" href="#output-liste-nur-totale-der-auswertung"><span>Output (Liste)(&quot;nur Totale der Auswertung&quot;)</span></a></h2>
<p>Zeilen:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Total:</td>
<td>Summe der einzelnen Spalten</td>
</tr>
<tr>
<td>Rekapitulation:</td>
<td>wie oben</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel &quot;detaillierte EB&quot;</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Stamm: Einzelbuchungen                      13.05.1999 10:33:37 leh  Seite     0</span>
<span class="line"> </span>
<span class="line"></span>
<span class="line">                        EB-Debitorenjournal per Stichdatum</span>
<span class="line"></span>
<span class="line">                 Achtung: Programm braucht 132 Zeichen / Zeile</span>
<span class="line"></span>
<span class="line">                 Personen-ID  von: 92,262,887 bis: 92,262,887</span>
<span class="line">                 Stichdatum.......:</span>
<span class="line">                 Ausgleichsdatum..:</span>
<span class="line">                 nur mit AdrFilter:</span>
<span class="line">                 Ausgabeformat....: (X) detaillierte EB</span>
<span class="line">                                    ( ) nur Totale pro Adresse / Fakturanummer</span>
<span class="line">                                    ( ) nur Total der Auswertung</span>
<span class="line">                 (ohne Sammelaufträge: nein/ja)</span>
<span class="line"></span>
<span class="line"> Adresse  FaktNr     Datum  T        Betrag EB Stichdatum EB Ausgleichsdat  Name</span>
<span class="line"> -------- ------ --------- -- ------------- ------------- ----------------  -------------------------</span>
<span class="line"> 92262887 2304959 29.10.98 A         290.40                                 Buchhandlung Muster</span>
<span class="line">        .       .        . G        -290.40</span>
<span class="line">        .       .        . GS        290.40</span>
<span class="line">        .       . 01.01.99 GS        290.40</span>
<span class="line">        .       . 02.03.99 G        -290.40       -290.40          -290.40</span>
<span class="line">                              ------------- ------------- ----------------  ------------------------</span>
<span class="line">                                     290.40       -290.40          -290.40                           Total</span>
<span class="line"></span>
<span class="line"> Alter der Forderungen per (EBStichd)</span>
<span class="line"> die per (EBAusgld) noch offen waren:  Anzahl           Wert</span>
<span class="line"> ------------------------------------ ------- --------------</span>
<span class="line">                  1 -  30  Tage            00           0.00</span>
<span class="line">                 31 -  60  Tage            00           0.00</span>
<span class="line">                 61 -  90  Tage            01        -290.40</span>
<span class="line">                 91 - 150  Tage            00           0.00</span>
<span class="line">                151 - mehr Tage            00           0.00</span>
<span class="line">                                       ------  -------------</span>
<span class="line">                Total                      01        -290.40</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Zeigt alle Einzelbuchungen zu den Fakturanummern für die Adresse 92262887, welche noch offen sind. Bei dieser Adresse blieb trotz verschiedener Korrekturbuchungen eine Forderung bestehen für einen Auftrag, der bereits 1998 ausgeführt wurde. Stichdatum und Ausgleichsdatum sind nicht eingegeben, entsprechen also dem Tagesdatum der Auswertung.</p>
<p>Outputbeispiel &quot;nur Totale pro Adresse / Fakturanummer&quot;</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"> Datenausgabe                                13.05.1999 14:37:49 leh  Seite     0</span>
<span class="line"> </span>
<span class="line"></span>
<span class="line">                        EB-Debitorenjournal per Stichdatum</span>
<span class="line">                 Personen-ID  von:            bis:</span>
<span class="line">                 Stichdatum       : 13.05.1999</span>
<span class="line">                 Ausgleichsdatum..: 13.05.1999</span>
<span class="line">                 nur mit AdrFilter:</span>
<span class="line">                 Ausgabeformat....: ( ) detaillierte EB</span>
<span class="line">                                    (X) nur Totale pro Adresse / Fakturanummer</span>
<span class="line">                                    ( ) nur Total der Auswertung</span>
<span class="line">                 (ohne Sammelauftr: nein/ja)</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"> Adresse  FaktNr     Datum  T        Betrag EB Stichdatum EB Ausgleichsdat Name</span>
<span class="line"> -------- ------ --------- -- ------------- ------------- ---------------- --------------------------</span>
<span class="line"> 92262887 2304959                                 -290.40          -290.40 Buchhandlung Muster</span>
<span class="line">        . 1234567                                 -100.00          -100.00</span>
<span class="line">                              ------------- ------------- ---------------- -------------------------</span>
<span class="line"> 92262887                                         -390.40          -290.40                          Total</span>
<span class="line">                              ------------- ------------- ---------------- ------------------------</span>
<span class="line">                                                  -390.40          -390.40                          Total</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"> Alter der Forderungen per 99.99.9999</span>
<span class="line"> die per EBAusgld) noch offen waren Anzahl           Wert</span>
<span class="line">             --------------------------------------------</span>
<span class="line">               1 -  30  Tage            00           0.00</span>
<span class="line">              31 -  60  Tage            00           0.00</span>
<span class="line">              61 -  90  Tage            01        -390.40</span>
<span class="line">              91 - 150  Tage            00           0.00</span>
<span class="line">             151 - mehr Tage            00           0.00</span>
<span class="line">                                    ------  -------------</span>
<span class="line">             Total                      01        -390.40</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Zeigt per 13.5.99 sämtliche Fakturen pro Adresse, welche zum gleichen Datum offen waren auf Basis der Einzelbuchungen.</p>
<p>Outputbeispiel &quot;nur Totale der Auswertung&quot;</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                                13.05.1999 14:37:49 leh  Seite     0</span>
<span class="line"> </span>
<span class="line"></span>
<span class="line">                        EB-Debitorenjournal per Stichdatum</span>
<span class="line">                 Personen-ID  von: 92,262,887 bis: 92,262,887</span>
<span class="line">                 Stichdatum       :</span>
<span class="line">                 Ausgleichsdatum..:</span>
<span class="line">                 nur mit AdrFilter:</span>
<span class="line">                 Ausgabeformat....: ( ) detaillierte EB</span>
<span class="line">                                    (X) nur Totale pro Adresse / Fakturanummer</span>
<span class="line">                                    ( ) nur Total der Auswertung</span>
<span class="line">                 (ohne Sammelauftr: nein/ja)</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"> Adresse  FaktNr     Datum  T        Betrag EB Stichdatum EB Ausgleichsdat Name</span>
<span class="line"> -------- ------ --------- -- ------------- ------------- ---------------- --------------------------</span>
<span class="line">                                                  -390.40          -390.40                           Total</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"> Alter der Forderungen per 99.99.9999</span>
<span class="line"> die per EBAusgld) noch offen waren:</span>
<span class="line">                                    Anzahl           Wert</span>
<span class="line">             --------------------------------------------</span>
<span class="line">               1 -  30  Tage            00           0.00</span>
<span class="line">              31 -  60  Tage            00           0.00</span>
<span class="line">              61 -  90  Tage            01        -390.40</span>
<span class="line">              91 - 150  Tage            00           0.00</span>
<span class="line">             151 - mehr Tage            00           0.00</span>
<span class="line">                                    ------  -------------</span>
<span class="line">             Total                      01        -390.40</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


